export enum FileInputError {
  Required = 'Required',
  InvalidFormat = 'InvalidFormat',
  MaxSizeExceeded = 'MaxSizeExceeded',
}
